export default {
  verificationReview: {
    open: '検証をレビュー',
    title: 'この実行を検証',
    description:
      '以下の未解決の項目を承認します。ソルバー結果と自動判定は変更されません。',
    automated: '自動判定: {{verdict}}',
    convergenceNotMeasured: 'この実行では収束を測定できませんでした。',
    noEvidence: 'この項目の追加の根拠は記録されていません。',
    confirm: '検証を確定',
    cancel: 'キャンセル',
    remove: '検証を取り消す',
    by: '{{name}} がレビュー · {{time}}',
    stale:
      '新しい実行があります。デザインポイントを更新してからレビューしてください。',
    ineligibleVerdict:
      '自動判定が {{verdict}} の間は検証レビューを使えません。',
    ineligibleNoUnresolved: '承認すべき未解決のソルバー検査はありません。',
    ineligibleMissingVerification:
      'この試行には自動検証の記録がないため、レビュー担当者による検証はできません。',
    setupWrongLead:
      '自動検査で設定の問題が見つかりました。失敗項目を直してから再実行してください。',
    setupWrongDetails: '詳細を見る',
    acceptDesignIntent: '設計意図として受け入れる',
    askAdvisorAboutSetup: 'アドバイザーに聞く',
    designIntentPrompt:
      'スタディ {{studyId}}、デザインポイント {{dpId}}（シミュレーション {{attemptId}}）。自動検証が設定不備を報告しました: {{summary}}。この実行では設計意図として扱い、失敗した設定検査を認めて検証済みにし、摩擦や壁近傍の数値を依然として採用不可とすべきかも述べてください。ソルバー結果は変えません。',
    designIntentSessionTitle: '設計意図 · 設定検査',
    setupWrongNoReview:
      '設定検査に失敗しています。ハンドカルクの関係をすべて承認すると検証済みになります。または設定を直して再実行してください。',
    retryMeshYplus:
      'これは境界条件の誤りではなく、壁近傍メッシュ（y⁺）の問題です。壁メッシュ（または y⁺ 目標）を調整して再実行してください。',
    yPlusDiagram: {
      aria: '壁面 y⁺ 帯：理想の低 Re（5未満）、この実行が落ちた緩衝帯（5–30）、理想の壁関数（30超）',
      axis: 'y⁺（第一セル）',
      lowRe: 'y⁺ < 5',
      buffer: 'y⁺ 5–30',
      wallFunction: 'y⁺ > 30',
      ideal: '理想',
      thisRun: 'この実行',
      thisRunFrac: 'この実行 · {{frac}}%',
      caption:
        '緑と青は妥当な壁面処理です。赤は緩衝帯でどちらの処理も使えません。そこにある壁面積は上限未満に抑えてください。',
    },
    retryFlowType:
      '流れの問題種別がこのメッシュと一致していません。内部流れ／外部流れの設定を確認し、再メッシュまたは再実行してください。',
    retryBoundaryConditions:
      '入口または遠方場の境界条件（速度・圧力・一様流）をケースと照合してから再実行してください。',
    retryContinueAfterSetup:
      '設定を直したあと、続行または再実行してください。この試行は信頼できる完了前に停止しています。',
    retrySetupGeneric:
      '下の失敗した設定項目を修正してから、デザインポイントを再実行してください。',
    checkNames: {
      wall_spacing: '壁面 y⁺ 分布',
      wall_spacing_target: '壁面 y⁺ 目標',
      mass_balance: '質量収支',
      energy_balance: 'エネルギー保存',
      boundary_flux_resolution: '境界熱流の分解能',
      temperature_bounds: '温度の上下限',
      flow_type: '流れの問題種別',
      stagnation: 'よどみ点圧力の検査',
      reference_area: '参照面積',
      length_scale: '長さスケール',
      convergence: '収束',
      thermal_resistance: '熱抵抗',
      port_vs_wall_closure: '冷媒の熱量 (ポート対壁面)',
      part_heat_balance: '部品ごとの熱収支',
      contacts_expected: '期待される接触',
      contact_area: '接触面積',
      heat_placement: '各部品自身のセル上の熱',
      contact_pressure: '接触圧力',
      displacement_scale: '変位スケール',
      stress_resolution: '応力の分解能',
    },
  },
  handCalc: {
    workspaceViews: '手計算の表示',
    resultsTab: '結果',
    relationsTab: '関係式',
    assumptionsTab: '前提条件',
    aiNote: 'AI のメモ',
    savedChecks: '保存済みの関係式チェック',
    checksSummary: '関係式チェック · {{approved}}/{{total}} 件承認済み',
    checksAgentWrittenAside_one:
      '· エージェント作成 {{count}} 件（関係式で確認）',
    checksAgentWrittenAside_other:
      '· エージェント作成 {{count}} 件（関係式で確認）',
    relationApprovalDoesNotVerify:
      '関係式チェックの承認では実行ステータスは変わりません。未解決のソルバー検査を編集者が認める必要があるときだけ「検証をレビュー」を使います。',
    relationApprovalPromotesVerified:
      '設定または未解決のソルバー検査があるとき、カタログの関係式をすべて承認するとこの実行は検証済みになります。エージェントが書いた自由式は承認対象ではありません。',
    addedByYou: 'あなたが追加',
    addedByAI: 'AIが追加',
    addedByUser: 'ユーザーが追加',
    addedByOther: '{{name}} が追加',
    reviewed: 'ユーザーが確認済み',
    reviewedByYou: 'あなたが確認済み',
    reviewedByOther: '{{name}} が確認済み',
    approvedByYou: 'あなたが承認済み',
    approvedByOther: '{{name}} が承認済み',
    notReviewed: '未承認',
    approve: '承認',
    approveProposed: '承認',
    proposedNeedsRelations:
      'エージェントが書いた自由式（カタログテンプレートなし）。関係式タブで確認してください。承認はカタログテンプレートだけに適用され、この行は検証済みを妨げません。',
    clearApproval: '承認を取り消す',
    markReviewed: '確認済みにする',
    clearReview: '確認を取り消す',
    agentGenerated: 'AI が作成',
    structuralRelation: '実行結果とケース設定から',
    structuralRelationHelp:
      'この読み取り専用の関係式は、記録されたシミュレーション結果と送信したケース設定から構築されます。AIによる引用や追加ではありません。',
    referenceSource: {
      runResult: '実行結果',
      mesh: 'メッシュ',
      caseInput: 'ケース入力',
      wallNoFlow: '壁、質量の通過なし',
      derivedBalance: '収支から導出',
      balanceAt: '収支の対象',
      interface: '界面',
      region: '領域',
      typedFor: '{{relation}} に手入力（{{symbol}}）',
      fluidLibrary: '流体ライブラリ · {{material}} · {{property}}',
      reportedOncePerCase: 'ケース全体で1回だけ報告',
    },
    aiMissingCoolantInputs:
      '熱抵抗はモデル全体だけを検証します。流れと対流の検証には、冷却材の物性値と経路長が必要です。',
    aiExplanationGeneric:
      '一部の検証には追加の入力値または適切な対象範囲が必要です。関係式を確認してください。',
    sourceCopy: {
      netBalance: '流入＋この領域の発熱−流出。',
      sourceHeatPathAssumption:
        '熱源の全熱量がこの経路から出ると仮定します。この実行では未確認です。',
      hottestSolidAssumption: '実行結果の固体最高温度を使います。',
      thermalResistanceReference: 'モデル全体の熱抵抗の定義',
      steadyStateAssumption:
        '定常状態の仮定：この領域にエネルギーは蓄積しません。',
      surfaceHeatFluxSameFaceAssumption:
        'Q と A は同一面を指し、同じ最終ソルバーステップの値です。',
      surfaceHeatFluxAverageAssumption:
        'A は計測した面の面積です。これは平均値であり、局所ピーク熱流束ではありません。',
      surfaceHeatFluxReference: '表面熱流束、面積平均の定義',
      dynamicPressureReference: '非圧縮流れの動圧の定義',
      pumpingPowerRatioReference:
        '運ばれる熱量に対するポンプ動力の比（体積流量は相殺）',
      steadyFlowEnergyReference: '単相流の定常流動エネルギー式',
      massConservationReference:
        'White, Fluid Mechanics — 開口で法線速度が一様・密度が一定のときの検査体積の質量保存',
      steadySinglePhaseAssumption: '仕事も相変化もない定常単相流。',
      cpAtInletAssumption: 'c_p は入口温度で評価します。',
      massWeightedRiseAssumption:
        '上昇分は質量流量加重の出口平均から入口を引いた値です。',
      incompressibleReferenceSpeedAssumption: '非圧縮流れ。U は基準速度です。',
      incompressibleSinglePhaseAssumption: '非圧縮の単相流。',
      pressureDropWholeRegionAssumption: 'dp は流体領域全体の圧力損失です。',
    },
    jumpToRelation: '{{region}}の{{quantity}}の関係式を開く',
    jumpToEarlierStep: '元の関係式を開く：{{relation}}',
    seeRelation: '関係式を見る',
    relationsChip: '関係式',
    relationNotEvaluated: '関係式は未評価',
    relationError: {
      generic: '保存された値からこの式を計算できませんでした。',
      missingValue: '値がありません：{{symbols}}。',
      invalidSymbol: '{{symbol}}はこの関係式の記号ではありません。',
      solveFailed: '{{symbol}}を求められませんでした。',
      noRealValue: 'この関係式を満たす{{symbol}}の実数値はありません。',
    },
    thermalRelation: {
      surface_heat_flux: '表面熱流束',
      convection_heat_rate: '対流による熱流率',
      conduction_1d: '一次元熱伝導',
      heat_rate_from_rise: '冷却液が運ぶ熱量',
      thermal_resistance: '熱抵抗',
      thermal_resistance_series: '直列熱抵抗',
      conduction_resistance: '熱伝導抵抗',
      biot_number: 'ビオ数',
      nusselt_number: 'ヌセルト数',
      colburn_j: 'コルバーン係数',
      exchanger_effectiveness: '熱交換器の有効度',
      effective_film_coefficient: '有効熱伝達係数',
      pumping_power_ratio: 'ポンプ動力比',
      pipe_nusselt_dittus_boelter: 'ディタス・ベルターの管内相関式',
      axial_stress: '軸応力',
      shear_stress: 'せん断応力',
      bearing_stress: '支圧応力',
      net_section_stress: '正味断面応力',
      tearout_stress: '引き裂きせん断応力',
      eccentric_bending_stress: '偏心曲げ応力',
      yield_factor: '降伏安全率',
      bolt_separation_load: 'ボルト接合部の分離荷重',
      bolt_clamp_load: 'ボルト締付け荷重',
      friction_slip_capacity: '摩擦すべり耐力',
      beam_bending_stress: '梁の曲げ応力',
      cantilever_deflection: '片持ち梁のたわみ',
      simply_supported_deflection: '単純支持梁のたわみ',
      axial_extension: '軸方向伸び',
      euler_buckling_pinned: '両端ピン柱の座屈荷重',
      slenderness_ratio: '細長比',
      beam_first_bending_mode: '梁の一次曲げ固有振動数',
      rod_first_axial_mode: '棒の一次軸方向固有振動数',
      dynamic_pressure: '動圧',
      reynolds_number: 'レイノルズ数',
      skin_friction_one_seventh: '平板の表面摩擦係数',
      friction_velocity: '摩擦速度',
      first_cell_height: '目標 y+ に対する第1セル高さ',
      drag_from_coefficient: '抗力係数から求める抗力',
      lift_from_coefficient: '揚力係数から求める揚力',
      sphere_drag_schiller_naumann: '球の抗力相関式',
      thin_airfoil_lift: '薄翼の揚力',
      sudden_expansion_loss: '急拡大損失',
      duct_friction_laminar: '層流ダクトの摩擦係数',
      pipe_pressure_drop_laminar: '層流管路の圧力損失',
      pipe_pressure_drop_blasius: '乱流管路の圧力損失（Blasius）',
    },
    thermalRelationNote: {
      thermal_resistance_series: '各部材の断面積は同じです。',
      biot_number: '0.1未満なら、固体内の温度を一様とみなせます。',
      exchanger_effectiveness: '理想的な最大熱移動量に対する割合です。',
      pipe_nusselt_dittus_boelter:
        '近似式です。適用できる場合はGnielinski式を優先してください。',
    },
    calculatedResults: '手計算の結果',
    simulationResults: 'シミュレーション結果',
    simulationAndDerivedResults: 'シミュレーション結果とAI導出値',
    noMatchingRunValue: '対応する実行値なし',
    noHandCalcResult: '手計算なし',
    moreRunResults: 'その他のシミュレーション結果',
    uncheckedOutputs: '検証のない解析結果',
    uncheckedOutputsHelp:
      '解析が報告する値のうち、登録された関係式で検証されていないものです。最高温度のように場の極値であり、そもそも手計算で求まらないものもあります——それ以外は埋めるべきギャップです。',
    uncheckedOutputsHelpFlow:
      '解析が報告する値のうち、登録された関係式で検証されていないものです。壁面の最大圧力のように面上の極値であり、そもそも手計算で求まらないものもあります——それ以外は埋めるべきギャップです。',
    uncheckedOutputsHelpStructural:
      '解析が報告する値のうち、登録された関係式で検証されていないものです。最大応力のように場の極値であり、そもそも手計算で求まらないものもあります——それ以外は埋めるべきギャップです。',
    uncheckedOutputsHelpOther:
      '解析が報告する値のうち、登録された関係式で検証されていないものです。そもそも手計算で求まらないものもあり、それ以外は埋めるべきギャップです。',
    uncheckedReason: {
      declaredInput:
        'これは宣言した入力なので、自身と比較しても必ず一致します。有効な確認は逆です：実行結果から関係式を逆算し、解析がその宣言値を反映したかを見ます。',
      noClosedForm: {
        temperature_max:
          '任意形状上の節点最大値に閉形式はありません。最も近い関係式である集中熱容量温度は体平均しか出さず、しかも Bi 0.1 未満でのみ成立します。体平均とホットスポットを比べると、ピークを報告したいまさにその場合（等温でない体）に不一致と読めてしまいます。ピークの確認には手計算ではなく実行自身の場が必要です。',
        peak_temperature:
          '実行期間（または場）のピークに閉形式はありません。最も近い関係式である集中熱容量温度は体平均しか出さず、しかも Bi 0.1 未満でのみ成立します。体平均とホットスポットを比べると、ピークを報告したいまさにその場合に不一致と読めてしまいます。確認には手計算ではなく実行自身の場が必要です。',
        temperature_min:
          '最高温度と同じで、理由も同じです。場の極値であり、閉形式が生み出す量ではありません。',
        temperature_avg:
          '集中熱容量温度が本当の候補です——Bi 0.1 未満の体ではその T(t) が体積平均そのもの——しかし結果量として temperature を出すため、どの関係式の結果量とも一致しません。付け替えるのはこの表の一行ではなく後続の作業です。',
      },
    },
    declaredInputs: '入力した条件',
    backSolveHint: '{{relation}} を逆算して確認できます',
    declaredInputsHelp:
      '設定した境界条件や材料物性値です。自身と比較しても必ず一致するため、未検証とは言えません。有効なのは逆算です：関係式をその値について解き、解析が条件を反映したか確かめます。',
    whyNoHandCalc: '手計算がない理由',
    noHandCalcHelp:
      'これらは実行結果ですが、独立した検算の関係式が登録されていません。名前が一致するだけでは比較できません。',
    addHandCalc: '手計算を追加',
    addHandCalcAgent: 'Agent',
    addHandCalcLabel:
      '{{region}} の {{quantity}} について、エージェントに手計算の関係式を追加させる',
    addHandCalcChatTitle: '手計算 · {{quantity}} · {{region}}',
    addHandCalcChatPrompt:
      '{{region}} の {{quantity}} について手計算の検算を起草してください。実行は {{value}} {{unit}} を報告していますが、それを検算する関係式がありません。適切な関係式（カタログに無い場合は自由式）を提案し、同意があれば保存してください。平易な言葉で答えてください。ツール名や配線フィールド名は使わないでください。\n\n{{toolContext}}',
    askRegionHeat: '領域熱と符号について聞く',
    askRegionHeatAgent: 'Agent',
    askRegionHeatLabel:
      'これらの領域熱収支、サンキー図、符号の約束をアシスタントに説明させる',
    askRegionHeatTitle: '領域熱 · 符号',
    askRegionHeatNoTerms: '項なし',
    askRegionHeatNoLedgers: 'このページに領域熱収支は表示されていません。',
    askRegionHeatUnknownTerm: '熱流率',
    askRegionHeatCoverageComplete: '境界はすべて報告済み',
    askRegionHeatCoverageOneSided: '熱が一方向のみ',
    askRegionHeatCoverageIncomplete: '一部の境界が欠測',
    askRegionHeatCoverageLegacy: '古い部分台帳',
    askRegionHeatCoverageDerived:
      'カバレッジ: 未評価 — 収支が他の項から 1 つの項を算出したため, この領域は構成上閉じています',
    askRegionHeatLedgerLine:
      '- {{region}}（{{coverage}}）：入 {{inbound}} {{unit}}、出 {{outbound}} {{unit}}、残差 {{remainder}} {{unit}}；項（正は領域へ流入）：{{terms}}',
    askRegionLedgerLineNotAssessed:
      '- {{region}}（未評価）：{{lines}} が値を報告していないため、合計は境界の一部だけで収支ではありません。{{side}}報告されている項（領域への流入が正）：{{terms}}',
    askRegionNotAssessedNoInflow: '流入は報告されていません。',
    askRegionNotAssessedNoOutflow: '流出は報告されていません。',
    askRegionHeatPrompt:
      'このページの領域熱収支とサンキー図を説明してください。\n\n{{ledgers}}\n\n符号の約束を説明してください：正は領域への流入、サンキーの帯幅はその符号付き熱流、残差 = 入 − 出、平均温度変化があるとき加熱／冷却は温度を優先。そのうえで、これらの数値がこの実行で何を意味するか——評価済みの領域のうちどれが閉じていないか、未評価と記された領域ではどの境界が値を報告していないか（閉じていないとは呼ばないでください）、次に何を確認すべきか——を述べてください。平易な言葉で答えてください。サンキーを描き直さず、ツール名や coverage の列挙値、配線フィールド名も使わないでください。\n\n{{toolContext}}',
    askRegionMass: '領域の質量流量と符号について聞く',
    askRegionMassLabel:
      'これらの領域の質量流量収支と符号の約束をアシスタントに説明してもらう',
    askRegionMassTitle: '領域の質量流量 · 符号',
    askRegionMassNoLedgers:
      'このページには領域の質量流量収支が表示されていません。',
    askRegionMassUnknownTerm: '質量流量',
    askRegionMassCoverageOneSided: '流れが一方向のみ',
    askRegionMassPrompt:
      'このページの領域の質量流量収支を説明してください。\n\n{{ledgers}}\n\n符号の約束を説明してください：正は領域への流入、残差 = 入 − 出。そのうえで、これらの数値がこの実行で何を意味するか——評価済みの領域のうちどれが閉じていないか、未評価と記された領域ではどの開口部が値を報告していないか（閉じていないとは呼ばないでください）、次に何を確認すべきか——を述べてください。平易な言葉で答えてください。ツール名や coverage の列挙値、配線フィールド名は使わないでください。\n\n{{toolContext}}',
    askRelationAgent: 'Agent',
    askRelationEquation: 'この式について尋ねる',
    askRelationEquationLabel: '{{title}} の式と文脈を助手に説明してもらう',
    askRelationEquationTitle: '関係式 · {{title}}',
    askRelationEquationPrompt:
      'ページ上のこの手計算の関係式を説明してください。\n\n名前: {{title}}\n場所: {{scope}}\n種類: {{source}}\n式: {{tex}}\n表示されている入力: {{givens}}\n結果: {{result}}\n\nこの式がここで何を意味するか、上の数値で各記号が何に対応するか、適用の限界は何かを述べてください。平易な言葉で答えてください。入力行をすべて繰り返さず、ツール名や id を言わず、求められない限り関係式を変更しないでください。\n\n{{toolContext}}',
    askRelationBacksolve: '逆算について尋ねる',
    askRelationBacksolveLabel:
      '{{title}} の逆算が実行の検証に役立つか助手に尋ねる',
    askRelationBacksolveTitle: '逆算 · {{title}}',
    askRelationBacksolvePrompt:
      'この手計算の関係式をひっくり返して実行の検証に使えるか、助言してください。\n\n名前: {{title}}\n場所: {{scope}}\n式: {{tex}}\nいまの向き: {{direction}}\n表示されている入力: {{givens}}\n結果: {{result}}\n比較: {{comparison}}\n\n代わりに何を解けるか、それが実行や宣言した入力の確認にどうつながるかを説明してください。順方向がすでに許容帯内、有用な未知数がない、宣言入力の言い直しになる、など価値がない場合ははっきりそう言ってください。説明のあと私が求めた場合を除き、変更を依頼・保存しないでください。平易な言葉で答え、ツール名や配線フィールド名は使わないでください。\n\n{{toolContext}}',
    askRelationVerdict: 'この判定について尋ねる',
    askRelationVerdictLabel: '{{title}} の判定と仮定を助手に説明してもらう',
    askRelationVerdictTitle: '関係式の判定 · {{title}}',
    askRelationVerdictPrompt:
      'この手計算の関係式の判定を説明してください。\n\n名前: {{title}}\n場所: {{scope}}\n式: {{tex}}\n結果: {{result}}\n比較: {{comparison}}\n仮定: {{assumptions}}\n参照: {{reference}}\n承認: {{approval}}\n問題: {{error}}\n\nページが示していること——許容帯との一致／不一致、実行が未確認の仮定（例：熱源の熱がすべてこの経路から出る）、関係式の承認は実行の検証とは別——を説明してください。何が確認済みで何が未確認か、次の具体的な確認を一つ述べてください。平易な言葉で答え、ツール名や配線フィールド名は使わないでください。\n\n{{toolContext}}',
    askRelationToolContext:
      'ツール用の文脈のみ — 私には繰り返さないでください: スタディ {{studyId}}、設計点 {{dpId}}、試行 {{attemptId}}。詳細が必要なら画面上の設計点の手計算レコードを読んでください。',
    addHandCalcToolContext:
      'ツール用の文脈のみ — 私には繰り返さないでください: スタディ {{studyId}}、設計点 {{dpId}}、試行 {{attemptId}}、確認する fact {{factId}}。詳細が必要なら画面上の設計点の手計算レコードを読んでください。',
    askRelationSourceLibrary: 'カタログの関係式',
    askRelationSourceOther: '独自の関係式',
    askRelationNoTemplate: 'なし（自由／構造）',
    askRelationNoGivens: '表示なし',
    askRelationNoComparison: 'このカードに比較なし',
    askRelationNoBand: '許容帯なし',
    askRelationBandPct: '許容 ±{{value}}%',
    askRelationBandUnknown: '帯域未採点',
    askRelationWithinBand: '許容帯内',
    askRelationOutsideBand: '許容帯外',
    askRelationComparisonLine: '差 {{delta}}（{{band}}；{{within}}）',
    askRelationNoAssumptions: 'なし',
    askRelationNoReference: 'なし',
    askRelationNoAttach: 'このカードでは向きを変えられません',
    askRelationApproved: 'レビュー担当者が承認済み',
    askRelationNotApproved: 'まだ未承認',
    askRelationNoSolveFor: '未知数が未選択',
    askRelationSolvingFor: '{{symbol}} を解く',
    askRelationNoTarget: '技術者の目標値なし',
    askRelationDirectionForward: '順方向 — 式そのものの答えを解く',
    askRelationDirectionLine: '{{direction}}；{{solveFor}}；保持値 {{target}}',
    askRelationNoError: 'なし',
    openRelations: '関係式を見る',
    noReferenceBand: '基準幅なし',
    noReferenceBandHelp:
      'この関係式には許容差が設定されていません。青は差があることを示すだけで、合否ではありません。',
    balanceChecks: '領域ごとの熱収支',
    balanceChecksHelp:
      '両方とも同じ領域の値です。入る熱と領域内で生じる熱を、出る熱と比べます。差は未計上の熱であり、測定された熱源や熱の出口ではありません。',
    balanceChecksHelpMass:
      '両方とも同じ領域の値です。入る質量流量を、出る質量流量と比べます。差は未計上の流れであり、測定された湧き出しや吸い込みではありません。',
    balanceChecksHelpOther:
      '両方とも同じ領域の値です。入る量と領域内で生じる量を、出る量と比べます。差は未計上の量であり、測定された発生源や出口ではありません。',
    symbolHelp:
      'この式では{{quantity}}を表します。実行結果の値を選ぶか、自分で入力できます。',
    symbolHelpLabel: '{{symbol}} の意味',
    editInput: '自分の値を使う',
    saveInput: '保存',
    chooseRunValue: '実行結果の値を選ぶ',
    useSourceValue: '元の値を使う',
    chooseSourceValue: '元の値を選ぶ',
    sourceGroup: {
      run: '実行結果から',
      handCalc: '手計算の結果から',
    },
    circularReference: '循環参照',
    circularReferenceHelp:
      '無効化された選択肢は関係式同士の循環参照になります。',
    catalogueReference: '参考資料',
    reportedIn: '流入の合計',
    reportedOut: '流出の合計',
    balanceHeating: '加熱',
    balanceCooling: '冷却',
    balanceDeltaTAvg: 'ΔT<sub>avg</sub>',
    balanceHeatRoleDeltaHelp:
      'ΔT_avg があるときは加熱／冷却は温度に従います。+ΔT は加熱（温まった）、−ΔT は冷却（冷えた）。',
    balanceHeatRoleLedgerHelp:
      'この領域に ΔT_avg はありません。加熱／冷却は熱台帳に従い、入るワットが出るワットより多いと加熱です。',
    balanceHeatRoleDeltaVsLedgerHelp:
      '加熱／冷却は ΔT_avg（温度）に従い、ワット列には従いません。領域は温まり（+ΔT）つつ熱が出ていくことがあります。バッジは温度変化、合計は熱台帳です。',
    balanceOutflowTo: '→ {{region}}',
    balanceInflowFrom: '← {{region}}',
    balanceSideOrigin: {
      from_run: '実行結果の報告値',
      agent_cited: 'AI引用',
      ai: 'AI導出',
      mixed: '混在：実行結果 + AI',
      balance: '収支から算出',
      declared: '宣言値',
      other: '実行結果以外',
    },
    ledgerTerms_one: 'この収支の項（{{count}} 件）',
    ledgerTerms_other: 'この収支のすべての項（{{count}} 件）',
    ledgerTermsIn_one: '流入の項（{{count}} 件）',
    ledgerTermsIn_other: '流入のすべての項（{{count}} 件）',
    ledgerTermsOut_one: '流出の項（{{count}} 件）',
    ledgerTermsOut_other: '流出のすべての項（{{count}} 件）',
    ledgerOneSided:
      '片側のみ：すべての項が同じ向きのため、この量を運び出す（または運び込む）モデル化された経路がありません。残差全体が未計上です。',
    ledgerIncomplete_one:
      '未評価：{{lines}} が値を報告していないため、領域境界の一部だけの和です。欠落はゼロではありません。',
    ledgerIncomplete_other:
      '未評価：{{count}} 個の境界（{{lines}}）が値を報告していないため、領域境界の一部だけの和です。欠落はゼロではありません。',
    ledgerLegacy:
      '領域台帳より前に作成：表示は各方向で最大の単一項であり、領域の合計ではありません。',
    ledgerDerived:
      '構成上のみ閉じています: 収支が他の項から 1 つの項を算出したため, ここでは食い違いうる値をランが何も測定していません。未評価。',
    ledgerOrigin: {
      solver: '実行結果',
      declared: '宣言値',
      derived: 'AI導出値',
      agent_cited: 'AI引用値',
      engineer: 'エンジニア入力値',
    },
    ledgerAgentCited_one:
      'AI引用の項を {{count}} 件含みます：実行に値がない箇所にAIが出典付きで入力した数値で、実行結果ではありません。',
    ledgerAgentCited_other:
      'AI引用の項を {{count}} 件含みます：実行に値がない箇所にAIが出典付きで入力した数値で、実行結果ではありません。',
    ledgerAgentGroup:
      'AI作成グループ：この領域に含める部品をAIが選んだため、この収支はケースが定義した境界ではなく、AIが引いた境界に対するものです。',
    ledgerAgentReshaped:
      'AIによる再グループ化：AIがこの領域に部品を出し入れしたため、境界はケースが定義したものではありません。',
    runReports: '実行結果',
    assumptions: '前提条件',
    noAssumptions: 'この実行では変更できる数値を使う式がありません。',
    saving: '保存中…',
    saved: '保存しました',
    reset: '編集内容をリセット',
    model: 'モデル全体',
    regions: '領域',
    region: '領域',
    relation: '式',
    runValueUnavailable: '実行結果の値がありません',
    regionsFoot:
      '界面は2つの領域が接することで生じるため、手動では作成しません。',
    filedCount_one: '{{count}} 件',
    filedCount_other: '{{count}} 件',
    filedHere_one: 'ここに式 {{count}} 件',
    filedHere_other: 'ここに式 {{count}} 件',
    noneHere: 'この領域にはまだ式がありません。式を追加してください。',
    ungroup: 'グループ解除',
    removeRejected: '拒否された項目を削除',
    gap: '収支が合わない',
    given: '与えられた値',
    step: 'ステップ {{position}} / {{total}}',
    result: '結果',
    net: {
      in: '領域への正味流入',
      out: '領域からの正味流出',
    },
    netRateHelp:
      '正の値は制御体積がこの量を得ていること、負の値は失っていることを示します。定常状態では正味の率はゼロに近づく必要があります。',
    derivedBalanceWarning:
      '別の領域収支から推定した境界値を含みます。この符号付きグラフ合計は、ソルバーのエネルギー収支結果ではありません。',
    rightClickUnits: '右クリックで表示単位を変更します。',
    proposed: 'エージェント作成',
    proposedHelp:
      'この境界に合うカタログの式がないため、エージェントがこの式を作成し出典を示しました。次元は検査済みですが、レビューされておらず、レポートには含まれません。',
    compareAgainst: '比較対象',
    band: '±{{value}}%',
    comparisons: '手計算と実行結果の比較',
    quantity: '物理量',
    calculated: '計算値',
    observed: '実行結果',
    difference: '差',
    differenceNotAssessed: '未評価',
    differenceNotAssessedHelp:
      'この領域の境界の一部が値を報告していないため、合計は境界の一部だけです。すべての境界が報告するまで差は表示しません。',
    bandColumn: '参照範囲',
    relationBandHelp:
      'この関係式で定めた許容差です。計算値が実行結果の ±{{value}}% 以内なら一致とみなします。',
    balanceBandHelp:
      '残差が対向する大きい方の流量の 1% 以下なら、収支は 1% 以内で閉じています。正は領域（または系）への純流入、負は純流出です。',
    noComparisons: 'この実行には、ここにある式と比較できる結果がありません。',
    loading: 'この実行の手計算を読み込んでいます…',
    loadFailed: '手計算を読み込めませんでした。',
    unavailable: 'この実行には手計算がありません。',
    noSavedRecord: 'この実行にはまだ保存された手計算がありません。',
    retry: '再試行',
    editFailed:
      'この変更は受け付けられず、保存されませんでした。以下の計算はそのままです。',
    markReviewFailed:
      '「{{relation}}」を承認できませんでした。変更は保存されていません。',
    clearReviewFailed:
      '「{{relation}}」の承認を取り消せませんでした。変更は保存されていません。',
    editOnAnotherRun:
      '変更は保存されましたが、この点は新しい実行に移りました。保存された計算を読むには開き直してください。',
    aiDraft: 'AIが作成し、その後編集されていません。',
    editedBy: '最終編集者: {{name}}。',
    editedByYou: '最終編集者: あなた。',
    draftedOnAnotherRun:
      'この計算は、この点の以前の実行に対して書かれたものです。',
    regenerate: '再作成',
    regenerating: '作成中…',
    regenerateTooltip:
      'アドバイザーに、この実行の手計算を新たに作成させます。ここに保存されているカタログ式・前提・手入力・比較目標は置き換わります。ケース由来の構造収支は残ります。',
    regenerateTooltipEdited:
      'アドバイザーに、この実行の手計算を新たに作成させます。ここに保存された内容は、ご自身が入力した値・目標・グループも含めてすべて置き換わります。ケース由来の構造収支は残ります。',
    regenerateTitle: 'この手計算を作成し直しますか？',
    regenerateWarning:
      'AIがこの実行の手計算を新たに書き、画面上のものはそれに置き換わります。現在の下書きには戻せません。',
    regenerateWarningEdited:
      'AIがこの実行の手計算を新たに書きます。ここに保存された内容は、ご自身が入力した値・目標値・グループも含めてすべて置き換わり、元には戻せません。',
    regenerateKeep: 'このままにする',
    regenerateConfirm: '置き換える',
    regenerateFailed:
      '手計算を作成し直せませんでした。下に表示されている保存済みの計算はそのままです。',
    askAssumptionSuggestions: '値を提案',
    askAssumptionSuggestionsLabel:
      'これらの前提の値をアシスタントに提案してもらう',
    askAssumptionSuggestionsTitle: '前提の値',
    askAssumptionSuggestionsPrompt:
      '下記の手計算の前提について、値を提案してください。\n\n現在の数値：\n{{facts}}\n\nこのうち {{editableCount}} 件は画面で入力できます。\n\nより良い値が必要な編集可能項目ごとに、この種の実行（流れ・共役伝熱・FEA 熱／構造のどれに合うか）に対する工学判断に基づく提案をしてください。場当たり的な推測より、公開材料ライブラリと第一原理の見積もりを優先してください。各提案が、支える検査に対して保守的か楽観的か、またこの設定で物理的に妥当か非物理的かを述べてください。ワイヤ上の欄名を捏造しないでください。説明のあとで私が頼むまで変更を保存しないでください。\n\n{{toolContext}}',
    askAssumptionValue: '値を提案',
    askAssumptionValueLabel:
      '{{region}} の {{quantity}} の値をアシスタントに提案してもらう',
    askAssumptionValueTitle: '前提 · {{quantity}} · {{region}}',
    askAssumptionValuePrompt:
      'この手計算の前提について値を提案してください。\n\n量：{{quantity}}\n領域：{{region}}\n現在値：{{value}}\n関係式：{{relation}}\n記号：{{symbol}}\n\nこの種の実行（流れ・共役伝熱・FEA 熱／構造のどれに合うか）に対する工学判断に基づく数値を提案してください。公開材料ライブラリと第一原理の見積もりを優先してください。提案が、支える検査に対して保守的か楽観的か、またこの設定で物理的に妥当か非物理的かを述べてください。ワイヤ上の欄名を捏造しないでください。説明のあとで私が頼むまで変更を保存しないでください。\n\n{{toolContext}}',
    askAssumptionNoFacts: 'まだありません',
    askAssumptionToolContext:
      'ツール用の文脈です。私には繰り返さないでください：スタディ {{studyId}}、デザインポイント {{dpId}}、試行 {{attemptId}}。詳細が必要なら開いているデザインポイントの手計算レコードを読んでください。',
    addRelation: '式を追加',
    relationLimit:
      'この手計算には {{max}} 件の式があり、1 つの記録に入る上限です。追加するには先に 1 件削除してください。',
    removeRelation: '削除',
    removeRelationLabel: '{{name}} をこの設計点から削除',
    confirmRemoveRelation: '削除する',
    cancelRemoveRelation: '残す',
    catalogue: 'カタログの式',
    catalogueCount: 'ここで使えるのは {{total}} 件中 {{applicable}} 件',
    chooseRelation: '式を選択',
    chooseFact: '値を選択',
    noOffers: 'この領域で追加できる式はありません。',
    optionalResult: '任意 — 実行結果と比較する場合に指定',
    leaveUnbound: '任意 — 指定しない',
    missingBinding: 'この実行には、この記号に必要な単位の値がありません。',
    needsTypedValue:
      'この実行には {{symbols}} の値がありません。入力すると追加できます。',
    attach: '追加する',
    typeValue: '値を入力',
    typedHere: 'ここで入力し、この領域の{{quantity}}として記録',
    gapQuantity: '{{quantity}}が閉じていません',
    gapTitle: '流入＋ここで宣言された量−流出。負の値は正味の流出を示します。',
    changeDirection: '向きを変える',
    directionTitle: '式を解く向き',
    directionHelp:
      '式をそのまま解くか、逆向きに解いて答えの出どころ（実行結果の値か、あなたが設定した目標値）を指定します。両方は指定できません。',
    directionForward: '式の答えである <sym/> を求める',
    directionBackwards: '逆向きに解く',
    solveFor: '求める記号',
    chooseUnknown: '記号を選択',
    holdFromRun: '<sym/> を実行結果の値に固定',
    useRunValue: '実行結果の値を使う',
    noRunValue: 'この実行には <sym/> を固定できる値がありません。',
    holdFromTarget: '<sym/> を目標値に固定 [{{unit}}]',
    targetReason: 'その目標値の根拠',
    useTarget: '目標値を使う',
    unitFor: '{{quantity}} の単位',
    flowTitle: '熱の行き先',
    flowView: '熱流の表示',
    flowWholeModel: 'モデル全体',
    flowRegions: '領域別',
    flowWholeScopeHelp:
      'モデル全体の収支は、宣言された入熱と外部境界の熱流率を使います。内部の熱移動は相殺されます。',
    flowRegionScopeHelp:
      '各領域は境界上のすべての項で個別に収支を取ります。各界面は一度だけ数えられるため、描画された領域の残差の合計はモデル全体の残差に一致します。1% 以内で閉じる領域は描画されません。',
    flowRegionSingleBodyHelp:
      'この実行には熱を担うボディが一つしかないため、「領域別」は「モデル全体」と同じ図になります。メッシュに複数体積（または CHT 領域／界面）があり、結果に面の所属があるときにボディ別の帯が現れます。',
    flowCaption:
      '帯は宣言された入熱と実行結果の熱流率（{{unit}}）を組み合わせています。橙色は計算した収支差であり、測定された熱流ではありません。',
    flowSource: '宣言された入熱',
    flowEnvironment: '外部境界',
    flowMissingIn: '計上されていない流入熱',
    flowMissingOut: '計上されていない流出熱',
    flowMoreLeaves: '流出が流入と内部発熱を上回る',
    flowMoreEnters: '流入と内部発熱が流出を上回る',
    flowNotAssessed: '部分和の残差：この領域の境界の一部が値を報告していません',
    flowLegend: 'エネルギーフローの凡例',
    flowLegendSource: '熱源 · 宣言された入熱',
    flowLegendTransfer: '伝達 · 領域間の熱',
    flowLegendSink: '流出先 · 外部境界',
    flowLegendDerived: 'AIによる導出または引用 · ソルバー報告値ではない',
    flowLegendBalanceDerived: '収支から算出 (未測定)',
    flowCitedByAgent:
      'AIが出典付きで入力。ソルバー報告値でも確認済みの値でもありません',
    flowCitedCaution:
      '一部の熱量はAIによる引用値で、ソルバーの測定値ではありません。',
    flowDetail: {
      temperature_change: '初期温度からのΔT<sub>avg</sub>',
      mass_flow: '質量流量 ṁ',
      inlet_temperature: '入口 T<sub>in</sub>',
      inlet_velocity: '入口速度 U<sub>in</sub>',
      outlet_temperature: '出口バルク温度 T<sub>out</sub>',
      outlet_velocity: '出口平均速度 U<sub>out</sub> = ṁ/(ρA)',
    },
    flowDetailEstimated: '領域から推定',

    flowDerivedByAgent:
      'AIが実行入力から導出。ソルバー報告値でも確認済みの値でもありません',
    flowDerivedByBalance: '収支から算出, 未測定',
    flowDerivedCaution:
      '境界の熱量はAIによる導出値で、ソルバーの測定値ではありません。',
    flowBalanceDerivedCaution:
      '灰色の帯はランが報告しなかったため収支から算出した値です。それだけで閉じる領域は未評価です。',
    flowLegendGap:
      '未計上の流入・流出 · 収支の差であり、測定された熱流ではありません',
    flowGapHelp:
      'この領域への流入熱と流出熱の報告値に差があります。この帯は不足分とその向きを示します。実際の熱源や放熱先ではありません。',
    assumptionEditable:
      '編集可能な仮定です。ユーザーまたはエージェントが保存済みの手計算値を変更できます。',
    assumptionReadOnly:
      'ソルバーが出力した、または別の記録済み事実から導出した読み取り専用の根拠です。',
    flowEmpty: 'この実行には描画できる値がありません。',
    flowAwaitingBoundary:
      'ケースには入熱が宣言されていますが、この実行では入口や出口の熱流率が報告されていません。AIは手計算の仮定や関係式を編集できますが、測定された境界熱流率は変更できません。全体の経路はまだ描けません。',
    flowUnreportedBoundaries: '熱流率が報告されていないケース境界: {{names}}。',
    flowTooltip: '{{label}}: {{value}} {{unit}}',
    flowTable: '流れを一覧で見る',
    flowLoop: '図には描画されません（流れが元の位置へ戻るため）',
    radarTitle: '各式と実行結果との差',
    radarCaption: '実行結果との差（符号なし）と、各式の公表された許容範囲。',
    radarDeviation: '実行結果との差',
    radarBand: '公表された許容範囲',
    radarNoBand: '許容範囲の公表なし',
    radarTooltip: '{{label}}: 実行結果との差 {{value}}%、許容範囲 ±{{band}}%',
    radarTooltipNoBand: '{{label}}: 実行結果との差 {{value}}%',
    kind: {
      model: 'モデル',
      body: '固体',
      fluid: '流体',
      group: 'グループ',
      line: '境界',
    },
    kindHelp: {
      model: 'モデル全体の検査体積です。固体と流体をまとめたもの。',
      body: 'ケース内の一つの固体部品です。すべての固体の合計ではありません。システム全体の収支はモデル行です。',
      fluid:
        'ケース内の一つの流体領域です。すべての流体の合計ではありません。システム全体の収支はモデル行です。',
      group: '複数の部品を一つの検査体積として扱った名前付きグループです。',
      line: 'メッシュ上の一つの境界または界面です。',
    },
    provenance: {
      run: '実行結果',
      library: '材料ライブラリ',
      cited: 'AIが引用',
      engineer: '技術者が入力',
      engineerNamed: '{{name}} が入力',
      engineerYou: 'あなたが入力',
      step: '前のステップ',
      target: 'あなたの目標値',
    },
    direction: {
      fromRun: '実行結果から',
      fromTarget: '目標値から',
    },
    op: {
      attach: '式 {{position}}',
      reparent: 'グループ分け {{position}}',
      value: '数値 {{position}}',
      propose: 'エージェントの式 {{position}}',
    },
    quantityName: {
      area: '面積',
      volume: '体積',
      mass: '質量',
      density: '密度',
      kinematic_viscosity: '動粘度',
      specific_heat: '比熱',
      velocity: '速度',
      pressure: '圧力',
      pressure_drop: '圧力損失',
      total_pressure_drop: '全圧損失',
      mass_flow: '質量流量',
      mass_flow_net: '正味質量流量',
      volumetric_flow: '体積流量',
      temperature: '温度',
      temperature_max: '最高温度',
      temperature_min: '最低温度',
      temperature_avg: '平均温度',
      ambient_temperature: '周囲温度',
      initial_temperature: '初期温度',
      temperature_difference: '温度差',
      thermal_conductivity: '熱伝導率',
      film_coefficient: '熱伝達率',
      heat_rate: '熱流量',
      heat_rate_net: '熱流率の収支',
      heat_flux: '熱流束',
      force: '力',
      drag_force: '抗力',
      lift_force: '揚力',
      force_net: '正味の力',
      preload_force: '初期締付け力',
      displacement: '変位',
      von_mises_stress: 'ミーゼス応力',
      yield_strength: '降伏強度',
      bearing_stress: '支圧応力',
      bending_stress: '曲げ応力',
      biot_number: 'ビオ数',
      colburn_factor: 'コルバーンのj因子',
      drag_coefficient: '抗力係数',
      dynamic_pressure: '動圧',
      effectiveness: '熱交換効率',
      first_cell_height: '第一セル高さ',
      hydraulic_diameter: '水力直径',
      frequency: '周波数',
      friction_factor: '摩擦係数',
      friction_velocity: '摩擦速度',
      lift_coefficient: '揚力係数',
      loss_coefficient: '損失係数',
      nusselt_number: 'ヌセルト数',
      pumping_power_ratio: 'ポンプ動力比',
      reynolds_number: 'レイノルズ数',
      safety_factor: '安全率',
      shear_stress: 'せん断応力',
      skin_friction_coefficient: '表面摩擦係数',
      slenderness_ratio: '細長比',
      stress: '応力',
      thermal_resistance: '熱抵抗',
      thermal_time_constant: '熱時定数',
      time_period: '解析時間',
      volumetric_heat_density: '体積発熱密度',
      temperature_change: '初期温度からの温度変化',
      thickness: '厚さ',
      length: '長さ',
      angle_of_attack: '迎角',
      prandtl: 'プラントル数',
      elastic_modulus: '弾性係数',
      buckling_load: '座屈荷重',
      buckling_load_factor: '座屈荷重係数',
      second_moment_area: '断面二次モーメント',
      section_modulus: '断面係数',
      moment: 'モーメント',
      stiffness_fraction: '継手剛性比',
      friction_coefficient: '摩擦係数',
      stanton_number: 'スタントン数',
      wall_distance_ratio: '壁面距離比',
    },
  },
  generatedHandCalc: {
    exportSelectionTitle: 'エクスポートする計算を選択',
    exportSelectionHelp:
      '計算は最大8点、比較行32行、参考文献32件まで含められます。含める点を選ぶか、ライブ計算なしでエクスポートしてください。ソルバー結果はすべて含まれ、セッションの編集内容は保持されます。',
    exportSelectionLimit:
      '8点、比較行32行、参考文献32件以内に減らしてください。',
    exportRowCount: '比較行 {{count}} 行',
    exportSelected: '選択した計算をエクスポート',
    exportWithoutCalculations: 'ライブ計算なしでエクスポート',
    cancel: 'キャンセル',
    notGenerated:
      'この実行には保存済みの手計算がありません。設計点を開いて作成してください。',
    liveOnly: '設計点に保存された手計算を、この実行に対して再現したものです。',
    reportTitle: '手計算との比較',
    assumptions: '仮定',
    cause: '理由: {{text}}',
    empty: 'この実行の記載内容では収支を作成できません。',
    dropped: {
      unresolved_target_one:
        '境界条件 {{count}} 件は部位に対応付けられず、どの収支にも含まれていません',
      unresolved_target_other:
        '境界条件 {{count}} 件は部位に対応付けられず、どの収支にも含まれていません',
      contact_pair_one: '接触ペア {{count}} 件は部位に対応付けられませんでした',
      contact_pair_other:
        '接触ペア {{count}} 件は部位に対応付けられませんでした',
      tied_interface_one: '結合面 {{count}} 件は部位に対応付けられませんでした',
      tied_interface_other:
        '結合面 {{count}} 件は部位に対応付けられませんでした',
      missing_end_one: '線 {{count}} 本がグラフにない部位を指しています',
      missing_end_other: '線 {{count}} 本がグラフにない部位を指しています',
      duplicate_fact_one:
        '同じ部位に対して加算できない単位で {{count}} 件の数値が二重に記載されているため、最初のものだけを表示しています',
      duplicate_fact_other:
        '同じ部位に対して加算できない単位で {{count}} 件の数値が二重に記載されているため、それぞれ最初のものだけを表示しています',
      over_scope_limit_one:
        'この組立はひとつの応答に収まりません: 部位・境界 {{count}} 件とその収支が欠落しています',
      over_scope_limit_other:
        'この組立はひとつの応答に収まりません: 部位・境界 {{count}} 件とその収支が欠落しています',
      over_fact_limit_one:
        '記録された数値 {{count}} 件は応答に収まりませんでした',
      over_fact_limit_other:
        '記録された数値 {{count}} 件は応答に収まりませんでした',
      over_relation_limit_one:
        '収支 {{count}} 件は応答に収まらず、対応する部位は一覧に含まれていません',
      over_relation_limit_other:
        '収支 {{count}} 件は応答に収まらず、対応する部位は一覧に含まれていません',
    },
    unavailable: 'この実行に対する収支は作成されません。',
    gaps: '収支が合わない箇所',
    gapTerms: '最大の流入 {{inbound}}、最大の流出 {{outbound}}',
    gapTotals: '全 {{count}} 項の合計：流入 {{inbound}}、流出 {{outbound}}',
    difference: '流入の合計 − 流出の合計',
  },

  workbench: {
    // ENG-1843 — レール撤廃後の残存キー。比較・統計サーフェスの文字列と、
    // 共通 `ExportReportButton` が使用する `exportPdf*` 群。
    compare: '比較',
    compareTitle: '選択した設計点 {{n}} 件',
    compareClose: '表に戻る',
    comparePageLabel: '実行の比較',
    compareClear: '比較の選択をクリア',
    compareNeedsTwo:
      '比較するには完了したランを2つ以上選択してください — 上のメニュー、または表の比較列から選べます。',
    comparePickSlot: '比較対象 {{letter}}',
    comparePickAdd: '設計点を追加',
    comparePickRemove: '{{letter}} を比較から外す',
    compareOutputs: '出力(Aとの差)',
    compareInputsDiffer: '異なる入力',
    compareInputsIdentical:
      '比較対象の設計点で入力はすべて同一です — ソルバー、メッシュ、境界条件も一致しています。',
    compareInputsNoneShown:
      '比較対象の設計点で、単一値の入力に差異はありません。ソルバーパラメータなどの入れ子の設定はここでは比較されず、異なる可能性があります。',
    compareInput: '入力',
    compareViewers: '結果ビュー',
    compareLinkCameras: 'ビューを連動',
    compareSyncColourScale: 'カラースケールを同期',
    compareSyncField: 'フィールドを同期',
    compareSyncProbe: 'ラインプローブを同期',
    compareSyncSectionPlane: '断面を同期',
    compareResiduals: '収束',
    compareRun: 'ラン {{letter}}',
    residualsLoading: '残差を読み込み中…',
    residualsUnavailable: '比較対象のランに残差履歴がありません。',
    statsTitle: '完了ラン全体での各出力の分布',
    statsNumbers: '数値',
    statsDistribution: '分布',
    distributionStrip: '使用可能な {{n}} 点における {{label}}',
    distributionMean: '平均',
    distributionPoint: '設計点 #{{n}} · {{value}}',
    statsEmpty: '出力のある完了ランはまだありません。',
    statsExcluded_one: '使用可能な {{count}} 点で計算 — {{ids}} を除外。',
    statsExcluded_other: '使用可能な {{count}} 点で計算 — {{ids}} を除外。',
    statsReviewFailures: '失敗を確認',
    output: '出力',
    min: '最小',
    mean: '平均',
    max: '最大',
    spread: 'ばらつき(σ)',
    exportPdf: 'レポートを出力(PDF)',
    exportPdfPending: 'PDFを準備中…',
    exportDocxPending: 'Word文書を準備中…',
    exportPdfHint:
      '本文を除いた表と検証項目をPDFとして生成しダウンロードします。',
    exportWriteup: '本文を出力(PDF)',
    exportWriteupHint: '表と検証項目を除き、本文のみをダウンロードします。',
    exportWriteupDocx: '本文を出力(Word)',
    exportWriteupDocxHint:
      '表と検証項目を除き、本文を編集可能なWord文書としてダウンロードします。',
    exportWriteupMenu: '出力',
    pdfFormat: 'PDF',
    docxFormat: 'DOCX',
    retryExportFormat: '{{format}}を再試行',
    exportFormatReady: '{{format}}の準備ができました。',
    exportFormatFailed:
      '{{format}}を準備できませんでした。選択して再試行してください。',
    closeReportWriter: 'レポートライターを閉じる',
  },
  aiRetry: {
    regionLabel: 'AI リトライの実施内容',
    title: 'AI リトライが失敗した {{total}} 件のうち {{count}} 件を回復した。',
    titleNone: 'AI リトライは失敗した {{total}} 件をどれも回復できなかった。',
    subline_one: '{{points}} は AI がリトライしたため結果に含まれている。',
    subline_other: '{{points}} は AI がリトライしたため結果に含まれている。',
    sublineNone: 'AI が試した内容を以下に示す。',
    show: 'AI の実施内容を表示',
    hide: 'AI の実施内容を隠す',
    stateRecovered: '試行 {{n}} で回復',
    stateRetrying: 'リトライ中 — 試行 {{n}} / {{max}}',
    stateRetryingNoMax: 'リトライ中 — 試行 {{n}}',
    stateGaveUp: 'AI が試行 {{n}} / {{max}} で停止',
    stateGaveUpNoMax: 'AI が試行 {{n}} で停止',
    stateDeclined: 'AI はリトライしなかった',
    ago: '{{ago}} 前',
    justNow: 'たった今',
    footer: 'このスタディの AI リトライすべて、新しい順。',
  },
  unusableRuns: {
    regionLabel: '使える結果が出なかったラン',
    title: '{{total}}点の設計点のうち{{count}}点で使える結果が出なかった。',
    outcomeCancelled: 'キャンセル',
    outcomeUnfinished: '未完了',
    outcomeRunning: '実行中',
    collapse: 'たたむ',
    expand: '開く',
    rowExpand: '設計点 {{n}} {{label}} に対する AI の実施内容を表示',
    rowCollapse: '設計点 {{n}} {{label}} のリトライ詳細を隠す',
    noRunToAmend: 'リトライできるランがない',
  },
  retryChat: {
    chatTooltip: 'この失敗についてリトライアドバイザーに聞く',
    chatAction: 'アドバイザーに聞く',
    chatAria: '設計点 {{n}} {{label}} の失敗についてチャットする',
    chatPrompt:
      'スタディ {{studyId}} の設計点 #{{n}} ({{label}}) は使える結果を出さなかった. 設計点 {{dpId}} の入力, ソルバー設定, ログを読み, 失敗の理由と変更すべき点を教えてほしい.',
    chatSessionTitle: 'リトライ助言 — {{label}}',
    retryTooltip: 'AI に設定を修正させてこの点を再実行する',
    retryAria: '設計点 {{n}} {{label}} を AI で再試行',
    retryAnywayAria: '設計点 {{n}} {{label}} を同じ設定のまま再試行',
  },
  sandbox: {
    noCompleted: 'シグナルを取り出せる完了ランがまだない.',
    failedHandCalc:
      'このランは完了前に停止しました。ランとの手計算比較には完了した結果が必要です。以下の記録済み診断データで原因を調べてください。',
    failedPlottingSubtitle:
      '停止したランの記録済み診断データです。部分的なデータであり、検証済みの結果ではありません。',
    dpLabel: '設計点',
    handInputsTitle: '手入力 (Hand inputs)',
    solverSignalsTitle: 'ソルバーシグナル (Solver signals)',
    radarTitle: 'L1 自己整合レーダー (L1 self-consistency radar)',
    selfConsistencyTitle: '自己整合チェック',
    plottingTitle: 'プロットセット (Plotting set)',
    plottingSubtitle: 'DOE + 検証 — 流れの分類と現時点の裏付けでタグ付け.',
    finalResiduals: '最終残差',
    wallYplus: '壁 y+',
    internalFlowSignals: '内部流シグナル',
    min: '最小',
    mean: '平均',
    max: '最大',
    notEmitted: 'この実行では出力されていない.',
    yplusBandsWarning:
      '面積分率 y+ バンド (<5 / 5–30 / 30–100 / >100) は BE 待ち — min/mean/max だけでは境界層被覆を隠せる.',
    legendLive: '出力済フィールドで裏付け',
    legendNeedsHand: '手入力が 1 つ必要',
    legendUnderDevelopment: '開発中 (Under development)',
    legendNotEvaluated: '未評価 — 入力が不足 (Not evaluated)',
    visibleTilesLabel: '表示中 {{visible}}/{{total}}',
    visibleTilesHeading: 'サンドボックスのタイル (Sandbox tiles)',
    showAll: 'すべて表示 (Show all)',
    hideAll: 'すべて非表示 (Hide all)',
    allTilesHidden:
      'すべてのタイルが非表示です — 上のドロップダウンから選択してください.',
    phase2Stub: '手入力と導出量は同ブランチの後続コミットで実装.',
    phase3Stub: '7 軸レーダーは同ブランチの後続コミットで実装.',
    phase4Stub:
      '自己整合表 (FREE / ID / GOOD バッジ + Δ / Δ%) は後続コミットで実装.',
    tiles: {
      handSolverParity: {
        title: '手計算 vs ソルバー比較 (hand vs solver comparison)',
        pickerDp: 'DP:',
        desc: '各量を 1 点でプロット, ±5% 許容帯を陰影で表示. 「サンドボックスは実行と一致するか」を表を読まずに確認.',
        emptyState: '上の手計算パネルを埋めると整合ドットが表示されます.',
        subtitle_one:
          '{{count}} 量 · ドット = (手計算 − ソルバー) / ソルバー · ±{{tolerance}}% は健全 · U 流入速度 · q 動圧 · Q 体積流量 · D 抗力 · C_D 抗力係数',
        subtitle_other:
          '{{count}} 量 · ドット = (手計算 − ソルバー) / ソルバー · ±{{tolerance}}% は健全 · U 流入速度 · q 動圧 · Q 体積流量 · D 抗力 · C_D 抗力係数',
        xAxisLabel: '(手計算 − ソルバー) / ソルバー (%)',
        yAxisLabel: 'ソルバー (Solver)',
        yAxisCaption:
          'Y: (手計算 − ソルバー) / ソルバー (%) — 0 の左は過小, 右は過大',
        tooltipHand: '手計算 (Hand)',
        tooltipSolver: 'ソルバー (Solver)',
        tooltipRatio: '比 (Ratio)',
        tooltipDp: 'DP',
        chartAriaLabel:
          '手計算 vs ソルバー 比較のドット {{count}} 量. Y 軸 Δ%, ±{{tolerance}}% の健全帯. 形状: 帯内は円, 帯外は三角, 15% 超は×.',
        rows: {
          u: 'U',
          q: 'q',
          q_flow: 'Q',
          drag: 'D',
          cd: 'C_D',
        },
        rowsFull: {
          u: '流入速度 (Inlet velocity)',
          q: '動圧 (Dynamic pressure)',
          q_flow: '体積流量 (Volumetric flow)',
          drag: '抗力 (Drag force)',
          cd: '抗力係数 (C_D)',
        },
      },
      coeffSettling: {
        title: '係数の収束エンベロープ (coefficient settling envelope)',
        desc: '最終ウィンドウでの C_D と C_D band. 「この値は収束したか, まだ振れているか」を返す.',
      },
      residualHistory: {
        title: '残差履歴の重ね描き',
        desc: '全 DP を単一の log 軸に. 発散した実行が集団から分離して見える.',
        emptyState: '選択中の DP にシミュレーションがまだ紐付いていない.',
      },
      convergenceHistory: {
        title: '収束履歴',
        desc: '記録された任意の量を反復回数に対して描く: 最高温の固体, ポート温度, 質量流量, 界面熱流束. 残差は場がまだどれだけ速く動いているかを示す. これは場が実際にどこにあるかを示し, 残差が平坦になった後も上昇し続けることがある.',
        emptyState: '選択中の DP にシミュレーションがまだ紐付いていない.',
      },
      gridConvergence: {
        title: '格子収束 (Richardson)',
        desc: 'メッシュ細分化に対する応答と外挿 h→0 値. 標準的な V&V エビデンス.',
        emptyState: 'この研究では GCI 解析が未実行.',
        subtitle: '{{response}} · GCI 細 {{gciFine}}% · 観測次数 p={{order}}',
        xAxisLabel: '格子サイズ h (mm) — 粗 → 細',
        extrapLabel: 'h→0',
        tooltipResponse: '応答',
        levelFine: '細',
        levelMedium: '中',
        levelCoarse: '粗',
        levelOther: '水準',
        chartAriaLabel:
          '格子収束曲線, {{response}} を {{levels}} 段のメッシュ水準で. GCI 細 {{gci}}%. X 軸は反転 (左=粗, 右=細), 破線が h→0 の外挿点.',
      },
      yplusBands: {
        title: 'y+ 被覆バンド',
        desc: '各 y+ バンドの壁面面積分率. サンドボックスのメモが既に指摘した BE 側フィールドが必要.',
      },
      carpet: {
        title: 'カーペットプロット (Carpet plot)',
        desc: 'スイープマトリクスをヒートグリッドで — 速度 × 圧力に対する 1 応答. DOE を作成時の形で読める.',
        emptyState: '各因子 2〜12 の一意値を持つ 2 因子スイープが必要.',
        subtitle: '{{yAxis}} × {{xAxis}} → {{response}}',
        emptyAmbiguous:
          'この格子の同じ点に複数の実行があり, 1 つのセルに答えが 2 つ以上ある. 別の入力の組を選ぶか, 重複する実行を取り除く.',
        emptyCellTooltip: 'この入力組合せに対する DP なし',
        pickerX: 'X 軸:',
        pickerY: 'Y 軸:',
        pickerZ: '色分け:',
        groupResponses: '結果 (Results)',
        chartAriaLabel:
          'カーペットプロット: {{rows}}×{{cols}} ヒートグリッド, Y={{yAxis}}, X={{xAxis}}, 色={{response}}.',
      },
      parallelCoords: {
        title: 'X–Y プロッター',
        desc: 'X と Y に任意の数値項目を選択. 完了 DP ごとに 1 点. 結果 vs 結果, 結果 vs 入力, または 結果 vs DP 番号.',
        emptyState: '完了 DP が 1 件以上, かつ数値結果が必要.',
        subtitle: '{{dps}} 個 DP · 完了 DP ごとに 1 点',
        pickerX: 'X 軸:',
        pickerY: 'Y 軸:',
        axisTitleHint: 'ダブルクリックでフィールド名を入力',
        groupMeta: '順序 (Order)',
        groupInputs: '入力 (Inputs)',
        groupResponses: '結果 (Results)',
        optionDpIndex: 'DP 番号 (DP #)',
        tooltipDp: 'DP',
        axisInput: '入力',
        axisResponse: '結果',
        chartAriaLabel:
          'X–Y プロッター: {{dps}} 個の DP, X={{xLabel}}, Y={{yLabel}}.',
      },
      sensitivityTornado: {
        title: '感度トルネード',
        desc: '各入力のスイープ範囲での応答振れ. 既存の感度パネルを拡張し, 各測定バーの後ろに手計算のゴーストバーを重ねる.',
        emptyState: 'Sobol 感度が未計算 — 研究の解析がまだ実行されていない.',
        subtitle: '{{response}} の主要ドライバー上位 {{count}} 件 (Sₜ)',
        tooltipSt: 'Sₜ (全次)',
        chartAriaLabel:
          '感度トルネード: {{response}} の主要ドライバー上位 {{count}} 件 (Sₜ). 負値は 0 の左側に伸びる.',
      },
      massBalance: {
        title: '質量収支ウォーターフォール',
        desc: '流入・流出と,その差を単一の基線上に. 表では位置づけの分からない 5.5e-7 の残差 (流入 0.128 に対して) が, ここでは「ほぼゼロ」と目で分かる棒になる.',
        emptyNoPoints: '完了した設計点がまだない.',
        emptyNoFlow:
          'この設計点には収支をとる入口・出口の流量がない. 流量のある実行は下の一覧で印なしで並ぶ.',
        tooltipFlowLabel: '流量',
        tooltipResidualLabel: '残差',
        pickerDp: '設計点:',
        noFlowTag: '流量なし',
        spokenUnits: {
          'm³/s': '毎秒立方メートル',
          'kg/s': '毎秒キログラム',
        },
        srInlet: '入口流量 {{value}} {{unit}}.',
        srOutlet: '出口流量 {{value}} {{unit}}.',
        srResidual: '残差 {{value}} {{unit}}, 流量スケールの {{pct}}%.',
        srRow: '{{name}}: {{value}} {{unit}}.',
        inlet: '入口',
        outlet: '出口',
        chartAriaLabel:
          '質量収支ウォーターフォール: 入口流量, 出口流量, その残差. 残差は流量スケールの {{pct}}%.',
      },
    },
  },
  boundaryConditionReview: {
    eyebrow: '境界条件のレビュー',
    title: 'シミュレーション前にパッチごとの物理を確認',
    descriptionHave_one: '{{count}} 個の設計点にメッシュがあります',
    descriptionHave_other: '{{count}} 個の設計点にメッシュがあります',
    descriptionWithout: '{{count}} 個は未生成',
    descriptionRest:
      '。各パッチに境界条件の物理（速度入口、圧力出口、壁面、自由流れ）を割り当ててください。このリストは研究内のすべてのメッシュに適用されます。',
    resumeStudy: '研究を再開',
    resumeFailed: '再開に失敗しました。',
    perPatchTitle: 'パッチごとの境界条件',
    loadingPatches: 'パッチを読み込み中…',
    withoutMesh_one: '{{count}} 個の設計点にメッシュがありません',
    withoutMesh_other: '{{count}} 個の設計点にメッシュがありません',
  },
  decideAnalysis: {
    iterationReview: 'イテレーション {{iteration}} のレビュー',
    iterationReviewFallback: 'イテレーションのレビュー',
    headerSubtitle: '収束、フロンティア、および提案される次の点',
    completed: '{{count}} 個完了',
    onFrontier: 'フロンティア上に {{count}} 個',
    hypervolumeTitle: 'ハイパーボリューム',
    hypervolumeEmptySubtitle: '完了したイテレーションはまだありません',
    hypervolumeSinglePointSubtitle:
      '次のイテレーションが完了すると軌跡を表示します',
    hypervolumeSinglePoint: 'イテレーション {{iteration}} • データ点は1つ',
    hypervolumeSubtitle: '高いほど良好 — 平坦化は収穫逓減の兆候です',
    hypervolumeLabel: 'ハイパーボリューム',
    axisIteration: 'イテレーション',
    changeFromPrevious: '前回のイテレーションからの変化',
    paretoTitle: 'パレートフロンティア',
    paretoEmptySubtitle:
      '最初のイテレーションが完了するとフロンティアが表示されます',
    paretoLabel: 'パレートフロンティア',
    paretoSubtitle_one: '非支配点 {{count}} 個 • 点のサイズ = HV 寄与',
    paretoSubtitle_other: '非支配点 {{count}} 個 • 点のサイズ = HV 寄与',
    hvContribution: 'HV 寄与：{{value}}',
    hvContributionOfBest: 'HV 寄与：{{value}}（最良値の {{pct}}%）',
    bestSoFarTitle: '現時点の最良',
    bestSoFarEmptySubtitle: '完了した実行はまだありません',
    designPoint: '設計点',
    frontierTableSubtitle:
      '{{objectives}} 個の目的にわたる {{count}} 個の非支配点 — HV 寄与で並べ替え',
    columnDp: 'DP',
    columnHv: 'HV',
    proposedForIteration: 'イテレーション {{iteration}} 向けの提案',
    candidatesSummary_one: '候補 {{count}} 個 • GP 平均予測を自然単位で表示',
    candidatesSummary_other: '候補 {{count}} 個 • GP 平均予測を自然単位で表示',
    acquisition: '獲得関数',
    acquisitionTooltip:
      '結合 qLogNEHVI 値 — 高いほど、このバッチから多くの HV 増加をオプティマイザが見込んでいます',
    noPredictions: 'この提案には予測が記録されていません。',
    columnDesignPoint: '設計点',
  },
  decideReview: {
    optimizerPaused: 'オプティマイザは一時停止中',
    reviewIteration: '続行する前にイテレーション {{iteration}} をレビュー',
    reviewIterationFallback: '続行する前にこのイテレーションをレビュー',
    proposedIntro: 'ベイズオプティマイザが提案しました',
    proposedPoints_one: '新しい設計点 {{count}} 個',
    proposedPoints_other: '新しい設計点 {{count}} 個',
    proposedOutro:
      'を次のバッチとして。続行してこれらを送出するか、現時点の結果で研究を停止してください。',
    cancelStudy: 'スタディをキャンセル',
    stopStudy: '研究を停止',
    continueIteration: 'イテレーションを続行',
    decisionFailed: '決定に失敗しました。',
  },
  paretoScatter: {
    downloadPng: 'チャートを PNG でダウンロード',
    downloadHtml:
      'チャートをスタンドアロンのインタラクティブ HTML でダウンロード',
    paretoFrontier: 'パレートフロンティア',
    otherCompleted: 'その他の完了',
    frontierLegend: 'パレートフロンティア（サイズ = HV 寄与）',
    onFrontier: 'フロンティア上',
    dominated: '支配される',
    otherResponses: 'その他の応答',
    designParameters: '設計パラメータ',
    hvContribution: 'HV 寄与：{{value}}',
    htmlHint: '任意の点にカーソルを合わせると設計パラメータが表示されます。',
  },
  sensitivity: {
    title: '感度',
    subtitle:
      '適合させたサロゲート上での Sobol 大域感度 — 入力ごとの分散寄与率、ブートストラップ信頼区間付き',
    trainingRows: 'サロゲートの訓練行数',
    dropped_one: '応答が不完全なため {{count}} 個の設計点を除外',
    dropped_other: '応答が不完全なため {{count}} 個の設計点を除外',
    saltelliEvals: 'サロゲートに対する Saltelli 評価',
    bootstrapResamples: '指標ごとのブートストラップ再標本化数',
    saltelliSeed: 'Saltelli シード',
    computedAt: '計算日時',
    noIndices: 'この応答には指標がありません',
    s1FirstOrder: 'S₁（一次）',
    stTotalOrder: 'Sₜ（全次）',
    interactionsDominateTooltip:
      '主要ドライバー {{input}}：効果の {{pct}}% が相互作用（Sₜ − S₁）によるもの',
    interactionsDominate: '相互作用が支配的',
    columnInput: '入力',
    deltaTooltip: 'Sₜ − S₁ — この入力を含む相互作用による分散の割合',
    varianceShare: '分散寄与率',
    interactionsDelta: '相互作用 Δ {{value}}',
  },
  surrogateValidation: {
    title: 'サロゲート検証',
    subtitle: 'Leave-one-out 診断 — 適合させた GP における予測値と実測値の比較',
    iteration: 'イテレーション {{iteration}}',
    completed: '{{count}} 個完了',
    logSpaceTooltip:
      'サロゲートは対数空間で適合しています。表示される値は自然単位に逆変換済みです',
    logSpaceFit: '対数空間適合',
    parityTitle: 'パリティ',
    paritySubtitle:
      '予測値と実測値 — y = x 上に狭い帯であれば GP は信頼できます',
    learningCurveTitle: '学習曲線',
    learningCurveSubtitle:
      'イテレーションごとの RMSE — サロゲートの収束に伴い平坦化します',
    r2Tooltip: 'GP サロゲートの Leave-one-out R²',
    coverageLabel: '95% 被覆',
    coverageTooltip: '±2σ 内に収まる LOO 真値の割合 — 0.95 付近が望ましい',
    axisActual: '実測値',
    axisPredicted: '予測値',
    axisIteration: 'イテレーション',
    tooltipActual: '実測値：{{value}}',
    tooltipPredicted: '予測値：{{value}} ± {{err}}',
    tooltipResidual: '残差：{{value}}',
    singlePoint:
      'イテレーション {{iteration}} • データ点は1つ — 次のイテレーションが完了すると軌跡が表示されます',
  },
  simError: {
    hideDetails: '詳細を隠す（{{count}} 行）',
    showDetails: '詳細を表示（{{count}} 行）',
    configErrorLine: '設定エラー · {{kind}}',
    foamFatalTitle: 'OpenFOAM 致命的エラー',
    solverDivergedTitle: 'ソルバーが発散',
    divergedIteration: 'イテレーション {{step}}',
    divergedUnknownIteration: '不明なイテレーション',
    divergedResidual: '残差',
    divergedIntro: '{{step}} で残差が数値範囲（NaN/Inf）を超えました。',
    divergedFieldNonFinite: 'フィールドが最初に非有限値になりました。',
    commonCauses: 'よくある原因（可能性が高い順）',
    causeFirstLayerSst:
      'k-ω SST に対して第一層セルが薄すぎます — 壁面付近で y+ < 5 が必要です。境界層をより緻密にしてメッシュを再生成してください。',
    causeFirstLayerRas:
      '選択した流れタイプに対して第一層セルが薄すぎます。乱流モデル使用時は特に壁面解像度に敏感です。',
    causeInletVelocity:
      'メッシュ解像度に対して入口速度が高すぎます（定常ソルバーでの CFL 的な不安定）。',
    causeBadMesh:
      '壁面付近のメッシュ不良 — 負体積セルです。メッシュページの品質レポートを確認してください。',
    causeRelaxation:
      '緩和不足係数が強すぎます。ソルバー → 詳細で、圧力・速度の緩和不足係数を下げてください（目安：圧力 ≤ 0.2、速度 ≤ 0.5）。',
    pressureSolveTitle: 'ソルバーが圧力解法でクラッシュ',
    pressureSolveIntro:
      '{{step}} で浮動小数点エラー — 通常は圧力ソルバーが低品質セルで破綻しています。',
    thingsToTry: '試すべきこと',
    tryPcg: '次で PCG / PBiCGStab に切り替え：',
    trySolverPExposed: '（公開されている場合）。',
    tryOneRegion:
      'メッシュに連結した流体領域が1つだけであることを確認してください（メッシュ品質レポート参照）。',
    tryReduceRelaxPPre: '次を減らす：',
    tryReduceRelaxPPost: '診断として1回の実行で 0.1 に。',
    chtFailedTitle: 'CHT ソルバーが失敗',
    chtIntro:
      '共役熱伝達には多領域メッシュが必要です — また CHT 境界条件のスキーマは external_flow と異なります。',
    chtPitfalls: 'よくある CHT の落とし穴',
    chtElementType: 'メッシュは element_type で生成する必要があります：',
    chtElementTypePost: '流体/固体界面用の face_tag を少なくとも1つ持つこと。',
    chtBoundaryConditionsPost:
      '流体領域用の FluidInletThermalBC を含める必要があります。',
    chtSolidBcs:
      '固体境界条件はパッチ名ではなく face_id（メッシュタグ）を使用します — external_flow とは異なるスキーマです。',
    diagnosisFieldLabel: '変更する入力',
    evidenceLabel: '実測値',
    evidenceContactPairs: '要求された接触ペア数',
    evidenceContactElements: '生成された接触要素数',
    evidenceIterations: '記録された反復数',
    evidenceResidualTrend: '残差',
    residualTrend: {
      falling: '低下中',
      flat: '横ばい',
      oscillating: '振動',
    },
    genericExitTitle: 'ソルバーがコード {{code}} で終了',
    genericExitBody:
      'この実行から構造化された失敗の詳細は抽出されませんでした。生のソルバーログで診断を確認してください。',
    preflightTitle: '研究を送信できませんでした',
    hints: {
      foamFatal: {
        patchFieldMissing:
          'メッシュにパッチは存在しますが、そのパッチに境界条件が設定されていません。不足しているパッチに対して boundary_conditions のエントリを追加してください。',
        unknownPatchType:
          'パッチタイプの不一致 — face_tags のラベルが予約名にサニタイズされた可能性があります。MeshGen の Boundary Assignment でタグの名前を変更してください。',
        keywordUndefined:
          'OpenFOAM のケース辞書に必須フィールドがありません — バックエンドのバグの可能性が高いです。ご報告ください。',
        polyMeshMissing:
          'メッシュのアップロードが不完全か破損しています。ジオメトリを再メッシュして再実行してください。',
      },
      config: {
        bcPatchMismatchTitle: 'パッチ名がメッシュと一致しません',
        bcPatchMismatchHint:
          'boundary_conditions が、メッシュの polyMesh に存在しないパッチを参照しています。BC エディタを開いて名前を確認してください — meshgen はラベルに `body_` を前置したり、複数面タグの場合に1つのラベルを `_000` / `_001` に分割したりすることがよくあります。',
        meshInvalidTitle: 'メッシュファイルを読み取れません',
        meshInvalidHint:
          '選択したメッシュの読み込みに失敗しました（polyMesh の破損、ファイルの欠落、または非対応フォーマット）。MeshGen からジオメトリを再メッシュして再送信してください。',
        bcMissingInletTitle: '速度ソースが定義されていません',
        bcMissingInletHint:
          '外部流れスタディには、速度を持つ境界条件（速度入口または自由流れ）を持つパッチが少なくとも1つ必要です。BC エディタを開いて設定してください。',
        bcMissingOutletTitle: '出口が定義されていません',
        bcMissingOutletHint:
          '少なくとも1つのパッチを圧力出口（外部空力の場合は自由流れ）に設定してください。圧力を固定する境界条件がないと、圧力方程式が有界でなくなり、ソルバーは最初のイテレーションで発散します。',
        bcInterfaceReservedTitle: '流体・固体界面パッチが再割り当てされました',
        bcInterfaceReservedHint:
          '境界条件の1つが、内部の流体・固体界面パッチ（`<a>_to_<b>`）を対象にしています。これらはエネルギー結合によって自動管理されており、役割を変更できません。その行を削除し、実際の境界パッチで壁面/入口/出口を選び直してください。',
        unknownTitle: '設定エラー',
      },
      preflight: {
        noInletVelocityTitle: '入口速度が設定されていません',
        noInletVelocityFix:
          '入口速度は 0 にできません。ステップ3 → 境界条件で、1つのパッチを「速度入口」または「自由流れ」に設定し、ゼロでない速度を指定してください。',
        bcMissingTitle: '境界条件が不足しています',
        bcMissingFix:
          'ステップ3 → 境界条件で、各メッシュパッチに物理（入口、出口、壁面など）を割り当ててください。',
        turbulentLengthScaleTitle: '乱流長さスケールが設定されていません',
        turbulentLengthScaleFix:
          'ソルバー設定 → 乱流で、長さスケールを物体の代表長さの約7〜10%に設定してください。',
        manualDpStaleInputTitle:
          '手動設計点が現在選択されていない入力を参照しています',
        manualDpStaleInputFix:
          'フラグ付きの手動設計点（プレビューで赤枠）を削除するか、対象のメッシュ/ジオメトリを再度選択してから、再実行してください。',
      },
    },
  },
} as const;
